import React, { useContext } from "react";
import { HomepageContext } from "@/components/header/ConnectedHeader";
import { RichTextContent } from "@/components";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import styles from "./GdprDownloadSection.module.css";

interface GdprDownloadSectionProps {
  location: string;
  className?: string;
}

export const GdprDownloadSection: React.FC<GdprDownloadSectionProps> = ({
  location,
  className,
}) => {
  const { data } = useContext(HomepageContext);

  if (!data?.career_section) return null;

  const {
    career_gdpr_text,
    career_gdpr_file,
    career_gdpr_file_title,
    career_gdpr_locations,
  } = data.career_section;

  const shouldRenderGdpr =
    Array.isArray(career_gdpr_locations) &&
    career_gdpr_locations.includes(location) &&
    career_gdpr_text &&
    career_gdpr_file &&
    career_gdpr_file_title;

  if (!shouldRenderGdpr) return null;

  return (
    <div className={`${styles.container} ${className || ""}`.trim()}>
      <RichTextContent content={career_gdpr_text} className={styles.text} />
      <a
        href={career_gdpr_file.url}
        className={styles.link}
        download
        target="_blank"
        rel="noopener noreferrer"
      >
        <PictureAsPdfIcon fontSize="small" />
        {career_gdpr_file_title}
      </a>
    </div>
  );
};
